import React, { useEffect, useRef } from 'react';
import loadScript from '../loadScript';
import './style.scss';

interface Props {
  id: string;
  extra: {
    widgetUrl: string;
    workspaceKey: string;
    workflowsToken: string;
    transactionLink?: { app: string };
    showSpinner?: boolean;
  };
  style?: object;
  onSubmit: (id: string, value: string | object) => void;
  onChange: (
    value: {
      id: string;
      value: string | object;
      error: boolean;
    },
    callback: () => void
  ) => void;
  onIframeLoad: () => void;
}

// eslint-disable-next-line no-underscore-dangle
declare let transactionlink: {
  open: () => void;
  setMode: (env: string) => void;
  navigateToApp: (app: string) => void;
  setWorkspaceKey: (workspase: string) => void;
  setContext: (token: string) => void;
  on: (
    command: string,
    callback: (command: {
      workflowId: any;
      partyId: any;
      customerId: any;
      commandType: string;
      status: string;
    }) => void
  ) => void;
  customerId: string;
  partyId: string;
};

const Widget: React.FC<Props> = ({
  id,
  extra,
  onChange,
  onSubmit,
  onIframeLoad,
}) => {
  const { widgetUrl, transactionLink, workspaceKey, workflowsToken } = extra;
  const mounted = useRef(false);
  const sendValue = (value: string | object) => {
    onChange(
      {
        id,
        value,
        error: false,
      },
      () => {
        onSubmit(id, value);
      }
    );
  };

  useEffect(() => {
    mounted.current = true;
    loadScript(widgetUrl, () => {
      onIframeLoad();
      transactionlink.setWorkspaceKey(workspaceKey);
      transactionlink.setContext(workflowsToken);
      transactionlink.open();
      transactionlink.on('workflow-finished', async command => {
        if (command.status === 'COMPLETED') {
          sendValue({
            workflowId: command.workflowId,
            partyId: command.partyId,
          });
        }
      });
    });
    return () => {
      mounted.current = false;
    };
  }, []);

  return <transactionlink-widget />;
};
export default Widget;
